import {
    createRouter, createWebHashHistory, RouteLocationRaw, RouteRecordRaw, useRoute,
} from 'vue-router';
import NumberOfTravellers from './views/NumberOfTravellers.vue';
import TravellersData from './views/TravellersData.vue';
import ServicesData from './views/ServicesData.vue';
import InvoiceData from './views/InvoiceData.vue';
import ReservationOverview from './components/ReservationOverview.vue';

export enum Route {
    NumberOfTravellers = 'NumberOfTravellers',
    TravellersData = 'TravellersData',
    ServicesData = 'ServicesData',
    InvoiceData = 'InvoiceData',
    Overview = 'Overview',
}

const routes: Array<RouteRecordRaw> = [
    { path: '/', name: Route.NumberOfTravellers, component: NumberOfTravellers },
    { path: '/TravellersData', name: Route.TravellersData, component: TravellersData },
    { path: '/ServicesData', name: Route.ServicesData, component: ServicesData },
    { path: '/InvoiceData', name: Route.InvoiceData, component: InvoiceData },
    { path: '/Overview', name: Route.Overview, component: ReservationOverview },
];

export const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

type CustomRouteOptions = Exclude<RouteLocationRaw, string>;

export const pushRoute = (name: Route, options?: CustomRouteOptions) => {
    router.push({
        ...(options || {}),
        name,
    });
};
